import { Component, OnInit } from '@angular/core';
import { TimeZoneApiModel } from 'src/AngularJS/Admin/IncontactFirstPhaseIntegration/first-phase-integration.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CXOneFirstPhaseIntegrationService, CXOneFirstPhaseIntegrationSharedData } from '../cxone-first-phase-integration.service';
import { KeyValue } from '@angular/common';

enum InContactRegionDomain {
    na1 = 0,
    na2 = 1,
    ca1 = 2,
    au1 = 3,
    eu1 = 4,
    uk1 = 5,
    jp1 = 6,
    na1dev = 7,
    na1test = 8,
    na1perf = 9,
    na1staging = 10,
    ae1 = 11,
    jo1 = 12,
    kr1 = 13,
    au2 = 14,
    eu2 = 15,
    uk2 = 16,
    //none = -1
}

@Component({
  selector: 'cv-cxone-first-phase-integration',
  templateUrl: './cxone-first-phase-integration.component.html',
  styleUrls: ['./cxone-first-phase-integration.component.scss']
})
export class CXOneFirstPhaseIntegrationComponent implements OnInit {
    private isDataLoading = false;

    public fpis: CXOneFirstPhaseIntegrationSharedData;
    public timeZones: TimeZoneApiModel;
    public subDomainBase: string = null;
    public subdomainPristine = true;
    public subdomainAvailable = false;
    public subdomainValid = false;
    public validatingSubdomain = false;
    public validationFailed = false;
    public validationTzFailed = false;
    public submittingCompany = false;
    public cvAngularTimeFormat: string = window["CVAngularTimeFormat"];
    public localization;
    public regionKeys = [];

    constructor(
        private cvLocalizationFactory: CVLocalizationService,
        private cxoneFirstPhaseIntegrationService: CXOneFirstPhaseIntegrationService,
    ) {
        this.fpis = this.cxoneFirstPhaseIntegrationService.dataObj;
    }

    async ngOnInit() {
        this.localization = await this.cvLocalizationFactory.GetSection("First_Phase_Integration");
        const StringIsNumber = value => isNaN(Number(value)) === false;
        this.regionKeys = Object.keys(InContactRegionDomain).filter(StringIsNumber).map(key => InContactRegionDomain[key]).sort();
        await this.loadTimezones();
        await this.loadSubDomainBaseValue();
    }

    private async loadTimezones() {
        if (this.isDataLoading)
            return; // Don't have multiple outgoing requests
        this.isDataLoading = true;

        try {
            this.timeZones = await this.cxoneFirstPhaseIntegrationService.loadTimeZones();
        } catch (err) {
            console.log(err);
        } finally {
            this.isDataLoading = false;
        }
    }

    private async loadSubDomainBaseValue() {
        if (this.isDataLoading)
            return; // Don't have multiple outgoing requests
        this.isDataLoading = true;

        try {
            this.subDomainBase = await this.cxoneFirstPhaseIntegrationService.loadSubDomainBase();
        } catch (err) {
            this.subDomainBase = null;
            console.log(err);
        } finally {
            this.isDataLoading = false;
        }
    }

    public originalOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
        return 0;
    }

    public async createCompany() {
        this.submittingCompany = true;
        let incontactPass = await this.validateInc();
        this.subdomainPristine = false;
        let subdomainPass = await this.validateSubdomain();
        let tzDefaultPass = this.validateTimezoneDefault();

        if (incontactPass && subdomainPass && tzDefaultPass) {
            try {
                await this.cxoneFirstPhaseIntegrationService.createCompany();

                // Reset form after successful save
                this.fpis.save.CompanyName = "";
                this.fpis.save.SubdomainName = "";
                this.fpis.save.TimeZoneDefault = "Not Set";
                this.fpis.save.ExtraTimeZone1 = "Not Set";
                this.fpis.save.ExtraTimeZone2 = "Not Set";
                this.fpis.save.ExtraTimeZone3 = "Not Set";
                this.fpis.save.CredentialPrimary = "";
                this.fpis.save.CredentialSecret = "";
                this.fpis.save.Domain = "na1";
                this.fpis.save.UseCaseSensitiveRawData = true;
            } catch (err) {
                console.log(err);
            }
        }
        else {
            if(!incontactPass)
                this.validationFailed = true;

            if (!tzDefaultPass)
                this.validationTzFailed = true;
        }

        this.submittingCompany = false;
    }

    public async validateInc() {
        return await this.cxoneFirstPhaseIntegrationService.validateInc();
    }

    public async validateSubdomain() {
        if (!this.validatingSubdomain && this.fpis.save.SubdomainName.length > 0) {
            this.validatingSubdomain = true;
            // Check for subdomain availability
            try {
                this.subdomainAvailable = true; //since dns is no longer created the availability is not needed
            } catch {
                this.subdomainPristine = true;
                this.validatingSubdomain = false;
            }

            // Invalid if it doesn't only contains numbers, letters and hyphens
            this.subdomainValid = /^[a-z0-9A-Z-]+$/.test(this.fpis.save.SubdomainName);

            this.validatingSubdomain = false;

            return this.subdomainAvailable && this.subdomainValid;
        }

        if (this.fpis.save.SubdomainName == "")
            this.subdomainPristine = true;
    }

    public validateTimezoneDefault() {
        if (this.fpis.save.TimeZoneDefault == null || this.fpis.save.TimeZoneDefault == "" || this.fpis.save.TimeZoneDefault.toLocaleLowerCase() == "not set")
            return false;

        return true;
    }

    public autoSuggestSubdomain() {
        if (this.subdomainPristine)
            this.fpis.save.SubdomainName = this.fpis.save.CompanyName.toLowerCase().replace(/\s/g, '');
    }

    public clearSelections() {
        this.fpis.save.ExtraTimeZone1 = "Not Set";
        this.fpis.save.ExtraTimeZone2 = "Not Set";
        this.fpis.save.ExtraTimeZone3 = "Not Set";
    }
}



